import { type MutableRefObject, useMemo, useState } from 'react'

import type { Invoice, InvoiceDetail, InvoiceTransaction } from '../../../../../api/useFreight/types'
import type { GridApi } from 'ag-grid-community'

export const useFilteredLineItems = ({
  selectedInvoice,
}: {
  selectedInvoice: Invoice | null
}) => {
  const [selectedAccessorialType, setSelectedAccessorialType] = useState<string | null>(null)
  const [selectedOrder, setSelectedOrder] = useState<InvoiceTransaction | null>(null)

  // Filter freight lines based on selected order and type
  const filteredFreightLines = useMemo(() => {
    if (!selectedInvoice || selectedInvoice.transactions.length === 0) return []

    let items = []

    // Filter by selected order if any
    if (selectedOrder) {
      items = selectedInvoice.transactions.filter(
        (transaction) => transaction.order_number === selectedOrder.order_number
      )
      items = items.flatMap((transaction) => transaction.details)
    } else {
      items = selectedInvoice.transactions.flatMap((transaction) => transaction.details)
    }

    // Filter by selected type if any
    if (selectedAccessorialType) {
      if (selectedAccessorialType === 'Base Freight') {
        items = items.filter((line) => ['Base Freight', 'Point To Point'].includes(line.type))
      } else {
        items = items.filter((line) => line.type === selectedAccessorialType)
      }
    }

    return items
  }, [selectedInvoice, selectedOrder, selectedAccessorialType])
  return {
    setSelectedOrder,
    selectedOrder,
    selectedAccessorialType,
    setSelectedAccessorialType,
    filteredFreightLines,
  }
}
